module.exports = __webpack_public_path__ + "static/media/Modul.798ff444.mp4";